import React from 'react'
import { useTokenPrice } from '../hooks/useTokenPrice';

function TokenToDollor({tokenAddress, tokenAmount}) {
    const { price: tokenPrice } = useTokenPrice(tokenAddress);
    // console.log( "Token Price in TokenToDollor:===", tokenPrice, tokenAddress, tokenAmount);
    
    const dollorValue = tokenPrice && tokenAmount ? (tokenPrice * tokenAmount).toFixed(7) : null;
  return (
    <>
        {dollorValue ? `$${dollorValue}` : '0'}
    </>
  )
}

export default TokenToDollor